import React, { useState, useEffect } from "react";
import classNames from "classnames";

import { useTheme } from "../../styles/useTheme";

import Styles from "./Toggle.module.scss";

type Props = {
  name: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  alternative?: boolean;
};

const Toggle = ({ name, checked = false, disabled = false, onChange, alternative }: Props) => {
  const [IsOn, setIsOn] = useState(checked);
  const { primaryColorBackground, primaryColorBorder } = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsOn(e.target.checked);
    onChange(e);
  };

  useEffect(() => {
    setIsOn(checked);
  }, [checked]);

  return (
    <label
      className={classNames(Styles.toggle, {
        [Styles.off]: !IsOn,
        [Styles.on]: IsOn,
        [primaryColorBackground]: IsOn,
        [Styles.altBackground]: alternative,
        [primaryColorBorder]: alternative,
      })}
    >
      <input type="checkbox" name={name} checked={checked} disabled={disabled} onChange={handleChange} />
      <div
        className={classNames(Styles.toggleCircle, {
          [Styles.altToggle]: alternative,
          [primaryColorBackground]: alternative,
        })}
      />
    </label>
  );
};

export default Toggle;
